var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u5716\\u5C64_1",
    width: "200px",
    height: "200px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      width: "100%",
      height: "100%",
      backgroundSize: "initial",
      backgroundRepeatY: "initial",
      backgroundRepeatX: "initial",
      backgroundPositionY: "initial",
      backgroundPositionX: "initial",
      backgroundOrigin: "initial",
      backgroundImage: "initial",
      backgroundClip: "initial",
      backgroundAttachment: "initial",
      animationPlayState: "paused"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)",
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 76.5c-1.1 0-2-.9-2-2v-9.7c0-1.1.9-2 2-2s2 .9 2 2v9.7c0 1.1-.9 2-2 2z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2 73.6c-.2 0-.4 0-.7-.1-1-.4-1.6-1.5-1.2-2.6l3.2-9c.4-1 1.5-1.6 2.6-1.2 1 .4 1.6 1.5 1.2 2.6l-3.2 9c-.3.8-1.1 1.3-1.9 1.3z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1 67.8c-.4 0-.8-.1-1.1-.3-.9-.6-1.2-1.9-.5-2.8l5.3-7.8c.6-.9 1.9-1.2 2.8-.5.9.6 1.2 1.9.5 2.8L22.8 67c-.4.5-1 .8-1.7.8z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9 59c-.6 0-1.1-.2-1.5-.7-.7-.8-.6-2.1.2-2.8l7.7-6.7c.8-.7 2.1-.6 2.8.2.7.8.6 2.1-.2 2.8l-7.7 6.7c-.3.3-.8.5-1.3.5z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6 73.6c-.8 0-1.6-.5-1.9-1.3l-3.2-9c-.4-1 .2-2.2 1.2-2.6 1-.4 2.2.2 2.6 1.2l3.2 9c.4 1-.2 2.2-1.2 2.6-.2.1-.5.1-.7.1z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2 67.8c-.6 0-1.2-.3-1.6-.8l-5.8-7.8c-.7-.9-.5-2.1.4-2.8.9-.7 2.1-.5 2.8.4l5.8 7.8c.7.9.5 2.1-.4 2.8-.4.3-.8.4-1.2.4z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9 59c-.5 0-.9-.2-1.3-.5l-7.7-6.7c-.8-.7-.9-2-.2-2.8.7-.8 2-.9 2.8-.2l7.7 6.7c.8.7.9 2 .2 2.8-.4.4-1 .7-1.5.7z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 67.2c-20 0-36.6-15.4-41.2-20.1l-.1-.1c-.4-.4-1-1-1.4-1.9-.6-1.3 0-2.7 1.2-3.3 1.3-.6 2.7 0 3.3 1.2 0 .1.3.3.4.4l.2.2C16.6 47.9 32 62.2 50 62.2S83.4 48 87.6 43.6l.2-.2.5-.5c.6-1.3 2-1.8 3.3-1.3 1.3.6 1.8 2.1 1.3 3.3-.4.9-1 1.5-1.5 1.9l-.1.1C86.6 51.8 70 67.2 50 67.2z",
    style: {
      fill: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("metadata", {
    xmlnsD: "https://loading.io/stock/",
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("dName", {
    style: {
      animationPlayState: "paused"
    }
  }, "eye"), /*#__PURE__*/React.createElement("dTags", {
    style: {
      animationPlayState: "paused"
    }
  }, "close,eyelash,eyelid,see,view,privacy,invisible,private,eye,web application"), /*#__PURE__*/React.createElement("dLicense", {
    style: {
      animationPlayState: "paused"
    }
  }, "by"), /*#__PURE__*/React.createElement("dSlug", {
    style: {
      animationPlayState: "paused"
    }
  }, "wijxpz"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.de6e8a00fe0e5d4e833cd9912f2f96be.svg";
export { ForwardRef as ReactComponent };